import React from "react";
import { Button } from "../../common/Button/Button";
import ReactTable from "react-table";
import "react-table/react-table.css";
import moment from "moment";
import Spinner from "../../common/Spinner/Spinner";
import Select from "react-select";
import find from "lodash/find";
import { ControlledInput } from "../../common/Input/Input";
import ESPNotesLogDropdown from "../../containers/EServicePartnerServiceRequests/ESPNotesLogDropdown";
import ReactDatePicker from "react-datepicker";
import { getUser } from "../../utils/localStorage";
import MultiSelectAll from "../../common/Multiselect/MultiSelectAll";
import SelectServiceStatusDropdown from "../EServicePartnerServiceRequests/SelectServiceStatusDropdown";
import { useEffect } from "react";
import { useState } from "react";

import withFixedColumns from "react-table-hoc-fixed-columns";
import "react-table-hoc-fixed-columns/lib/styles.css";
import Pagination from "../../common/Pagination/Pagination";
import CentralizedNotesModal from "../ServiceRequests/Handholder/CentralizedNotesModal";
const ReactTableFixedColumns = withFixedColumns(ReactTable);

export default function SPLedServiceRequestGrid(props)
{
	//const reactTable = React.createRef(); need this to uncomment
	/*useEffect(() => {
		reactTable.current.props.onPageChange(props.page);
	}, props.page);*/
	const [Tablecolumns,setTablecolumns] = useState([]);

	const [showViewAllNotesModal, setShowViewAllNotesModal] = useState(false);
	const [selectedCustomerEmailId, setselectedCustomerEmailId] = useState(null);
	const toggleViewAllNotesModal = () => {
		setShowViewAllNotesModal(!showViewAllNotesModal);
	};

	const handleViewAllNotes = (original) => {
		setselectedCustomerEmailId(original.sEmailAddress);
		toggleViewAllNotesModal();
	};

	const setColumns=()=>{
		const columns = [
			{
				Header: "Service and Customer Details",
				fixed: "left",
				columns: [
					{
						id: "instanceid_"+"nResourceInstanceId",
						Header: "Service Instance ID",
						headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
						accessor: "nResourceInstanceId",
						width: 80,
						className:"gray-bg"
						
					},
					{
						id: "sServiceName",
						Header: "Service Name",
						headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
						accessor: "sServiceName",
						width: 80,
						className:"gray-bg",
						Cell: ({ original }) => (
							original.sServiceName ? 
							original.sServiceName :
							original.refServiceType?
							original.refServiceType.sServiceName:
							""
						),
					},
					{
						id: "sPackageOfferTitle",
						Header: "Package/Offering Title",
						headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
						accessor: "sPackageOfferTitle",
						width: 80,
						className:"gray-bg",
						Cell: ({ original }) => (
							original.sPackageOfferTitle?
							original.sPackageOfferTitle:
							""
						),
					},
					{
						id: "sFirstName",
						Header: "First Name",
						headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
						accessor: "sFirstName",
						width: 80,
						className:"gray-bg",
						Cell: ({ original }) => (
							original.sFirstName ? 
							original.sFirstName :
							original.customer_meta?
							original.customer_meta.first_name:
							""
						),
					},
					{
						id: "sLastName",
						Header: "Last Name",
						headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
						accessor: "sLastName",
						width: 80,
						className:"gray-bg",
						Cell: ({ original }) => (
							original.sLastName ? 
							original.sLastName :
							original.customer_meta?
							original.customer_meta.last_name:
							""
						),
					},
					{
						id: "sEmailAddress",
						Header: "Customer Email",
						headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
						accessor: "sEmailAddress",
						width: 80,
						className:"gray-bg"
					},
					{
						id: "sContactNumber",
						Header: "Phone No.",
						headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
						accessor: "sContactNumber",
						width: 100,
						className:"gray-bg"
					},
				]
			},	
			{
				Header: "Other Information",
				columns: [
					{
						id: "dtRequested",
						headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
						Header: "Service Requested Date",
						accessor: "dtRequested",
						width: 100,
						Cell: ({ original }) =>
						original.dtRequested?(moment(original.dtRequested).format("DD/MM/YYYY")):("NA"),
						className:"gray-bg"
					},
					{
						id: "bRequestedCallBack",
						Header: "Request a Call Back",
						headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
						accessor: "bRequestedCallBack",
						Cell: ({ original }) => (original.bRequestedCallBack ? "Yes" : "No"),
						width: 80,
						className:"gray-bg"
					},
					{
						id: "bNeedToTalkToSP",
						headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
						Header: "Need to talk to SP",
						accessor: "bNeedToTalkToSP",
						Cell: ({ original }) => (original.bNeedToTalkToSP ? "Yes" : "No"),
						width: 80,
						className:"gray-bg"
					},
					{
						id: "request_by_"+"sExternalHHEmail",
						headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
						Header: "Request By User/EHH",
						accessor: "sExternalHHEmail",
						Cell: ({ original }) => (original.sExternalHHEmail ? "EHH" : "User"),
						width: 80,
						className:"gray-bg"
					},		
					{
						id: "bStayEngagedWithEhh",
						headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
						Header: "Language Barrier flag",
						accessor: "bStayEngagedWithEhh",
						Cell: ({ original }) => (original.bStayEngagedWithEhh ? "Yes" : "No"),
						width: 80,
						className:"gray-bg"
					},
					{
						id: "EHH_details"+"sExternalHHEmail",
						Header: "EHH Details",
						headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc','borderRight':'solid 1px #ccc'},
						accessor: "sExternalHHEmail",
						className:"right-boder",
						Cell:({ original }) => (
							<>
								<span>Name-{original.sEhhName?original.sEhhName:"NA"}</span><br></br>
								<span>Email-{original.sExternalHHEmail?original.sExternalHHEmail:"NA"}</span><br></br>
								<span>Number-{original.sEhhContactNumber?original.sEhhContactNumber:"NA"}</span><br></br>							
							</>
						),
						width: 120,
						className:"gray-bg"
					},
				]
			},
			{
				Header: "Service Progression Details",
				headerStyle:{'backgroundColor':'#75287C','color':'white'},
				columns: [
					{
						id: "cs_"+"nResourceInstanceId",
						Header: "Call Status",
						headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
						accessor: "nResourceInstanceId",
						width: 200,
						show:!getShowChargesColumn(),
						style: { 'whiteSpace': 'unset'},
						getProps: (state, rowInfo, column) => {
							return {
								style: {
									overflow: "visible",						
								},
							};
						},
						Cell:({original})=>(
							<>
								{
									props.selectedServiceForEdit&&props.selectedServiceForEdit.nResourceInstanceId&&props.selectedServiceForEdit.nResourceInstanceId===original.nResourceInstanceId?				
									(
										<>	
											{
												<Select
													placeholder={"Select call status"}
													//isClearable
													options={props.callStatusOptions}
													onChange={(e) =>props.onCallStatusOptionChange(e,original)}
													value={getSelectedItem(props.callStatusOptions,props.selectedServiceForEdit.custsCallStatus)}
												></Select>
											}
										</>							
									):
									(
										<>
											<span>{getSelectedItemLable(props.callStatusOptions,original.sCallStatus)||""}</span>
										</>
									)
								}
								
							</>
						)
					},
					{
						id: "custrefSRState",
						Header: "Service Status",
						headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
						accessor: "custrefSRState",
						width: 200,
						style: { 'whiteSpace': 'unset' },
						getProps: (state, rowInfo, column) => {
							return {
								style: {
									overflow: "visible",						
								},
							};
						},
						Cell:({original})=>(
							<>
								{
									props.selectedServiceForEdit&&props.selectedServiceForEdit.nResourceInstanceId&&props.selectedServiceForEdit.nResourceInstanceId===original.nResourceInstanceId?				
									(
										<Select
											placeholder={"Select Service Request State"}
											options={props.ServiceRequestsStatesOptions}
											onChange={(e) =>props.onServiceRequestsStateChange(e,original)}
											value={getSelectedItem(props.ServiceRequestsStatesOptions,props.selectedServiceForEdit.custrefSRState)}
										></Select>
										
									):
									(
										<>{original.custrefSRState=="Cancelled"||original.custrefSRState=="Delivered"?
										(
											<span>{original.custrefSRState}</span>
										):
										(
											//<span title="Double click to edit" onDoubleClick={(e) =>props.onRowDoubleClick(e,original)}>
											<span>
												{
													original.sPaymentReceiver=="Partner"?
													(
														original.custrefSRState=="Prepared"||
														original.custrefSRState=="Ready For Progression"?
														"Willing to Pay":
														original.custrefSRState=="Partial Payment Pending"?
														"Willing to Pay":
														original.custrefSRState=="Payment Confirmed By Partner"?
														"Payment Received":
														original.custrefSRState
													):
													original.custrefSRState=="Partial Payment Pending"?
													"Willing to Pay":
													original.custrefSRState=="Payment Received"||
													original.custrefSRState=="Ready For Progression"?
													"Payment Received":
													original.custrefSRState
												}
											</span>
										)}
										
										</>
									)
								}
							</>
						)
					},
					{
						id: "custsSRCancellationReason",
						Header: "Cancellation Reason",
						headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
						accessor: "custsSRCancellationReason",
						width: 280,
						style: { 'whiteSpace': 'unset' },
						getProps: (state, rowInfo, column) => {
							return {
								style: {
									overflow: "visible",
									'whiteSpace': 'unset'
														
								},
							};
						},
						Cell:({original})=>(
							<>
								{
									props.selectedServiceForEdit&&props.selectedServiceForEdit.nResourceInstanceId&&props.selectedServiceForEdit.nResourceInstanceId===original.nResourceInstanceId?				
									(
										<>	
											{
												<Select
													isDisabled={props.selectedServiceForEdit.custrefSRState!="Cancelled"?true:false}
													placeholder={"Select Cancellation Reason"}
													options={props.cancellationReasonDropdownOptions}
													onChange={(e) =>props.onCancellationReasonChange(e,original)}
													isClearable
													value={getSelectedItem(props.cancellationReasonDropdownOptions,props.selectedServiceForEdit.custsSRCancellationReason)}
												></Select>
											}					
											{props.selectedServiceForEdit.custsSRCancellationReason &&props.selectedServiceForEdit.custsSRCancellationReason==="Other"? 
											(
												<ControlledInput
													style={{marginTop:"5px",marginBotttom:"5px"}}
													placeholder="Please specify a reason here"
													name="custssSRCancellationReasonOtherDescription"
													onChange={({ target: { name, value } }) =>									
													props.handleServiceRequestsNotesChange(name, value)}
													autoComplete="off"
													value={props.selectedServiceForEdit.custssSRCancellationReasonOtherDescription}
													autoFocus={props.activeFocus==="custssSRCancellationReasonOtherDescription"}
													onFocus={(e)=>e.currentTarget.setSelectionRange(e.currentTarget.value.length, e.currentTarget.value.length)}	
												/>
											) : 
											(
												<>
												</>
											)}
										</>							
									):
									(
										<>
											<span>{original.custsSRCancellationReason?
												original.custsSRCancellationReason ==="Other"? 
												original.custssSRCancellationReasonOtherDescription: 
												original.custsSRCancellationReason:""}</span>
										</>
										
									)
								}
								
							</>
						)
					},
					{
						id: "Notes_"+"nResourceInstanceId",
						Header: "Notes",
						headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
						accessor: "nResourceInstanceId",
						width: 300,
						getProps: (state, rowInfo, column) => {
							return {
								style: {
									overflow: "visible",						
								},
							};
						},
						Cell:({original})=>(
							<>
								{
									props.selectedServiceForEdit&&props.selectedServiceForEdit.nResourceInstanceId&&props.selectedServiceForEdit.nResourceInstanceId===original.nResourceInstanceId?				
									(
										<>	
											{/*<ReactDatePicker
												dateFormat="dd/MM/yyyy"
												selected={
													props.selectedServiceForEdit.custdtFollowupOn
												}
												onChange={(date) =>
													props.handleServiceRequestsNotesChange("custdtFollowupOn", date)
												}
												minDate={new Date()}
												placeholderText="Followup On"
												style={{width:"100%"}}
			
											/>
											<textarea
												name="custsFollowupNotes"
												className="w-100 form-control rounded"
												value={
													props.selectedServiceForEdit.custsFollowupNotes||""
												}
												onChange={({ target: { name, value } }) =>
													props.handleServiceRequestsNotesChange(name, value)
												}
												style={{minHeight:"20px",marginTop:"5px"}}
												autoFocus={props.activeFocus==="custsFollowupNotes"}
												placeholder="Follow up actions"
												onFocus={(e)=>e.currentTarget.setSelectionRange(e.currentTarget.value.length, e.currentTarget.value.length)}
											/>*/}
			
											<textarea
												key={props.selectedServiceForEdit.nResourceInstanceId}
												className="w-100 form-control rounded"
												name="custsNotesHH"
												value={props.selectedServiceForEdit.custsNotesHH||""}
												onChange={({ target: { name, value } }) =>									
													props.handleServiceRequestsNotesChange(name, value)
												}					
												style={{minHeight:"20px"}}
												autoFocus={props.activeFocus==="custsNotesHH"}
												placeholder="Notes"
												onFocus={(e)=>e.currentTarget.setSelectionRange(e.currentTarget.value.length, e.currentTarget.value.length)}
											/>
			
										</>							
									):
									(
										<>
										<Button 
											onClick={(e) =>{		
												handleViewAllNotes(original);
											}}	
											style={{float:"left",marginRight:"15px"}}
											>
											View All Notes
										</Button>
										<ESPNotesLogDropdown 
										nResourceInstanceId={original.nResourceInstanceId}
										serviceFrom={original.serviceFrom}
										bNewNotesAdded={original.bNewNotesAdded}
										UpdateNewNotesFlag={(nResourceInstanceId) => {props.UpdateNewNotesFlag(nResourceInstanceId);}}/>
										{original.bNewNotesAdded?
										(
										<button style={{marginLeft:"5px"}}className={`notes-button`}>New</button>
										):("")}
										</>
									)
								}
								
							</>
						)
					},
					{
						id: "cnaos_"+"nResourceInstanceId",
						Header: "Does Customer need additional service?",
						headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
						accessor: "nResourceInstanceId",
						width: 280,
						style: { 'whiteSpace': 'unset'},
						getProps: (state, rowInfo, column) => {
							return {
								style: {
									overflow: "visible",						
								},
							};
						},
						Cell:({original})=>(
							<>
								{
									props.selectedServiceForEdit&&props.selectedServiceForEdit.nResourceInstanceId&&props.selectedServiceForEdit.nResourceInstanceId===original.nResourceInstanceId?				
									(
										<>	
											{
												<Select
													placeholder={"select customer need any other service"}
													options={props.customerNeedAnyOtherServiceOptions}
													onChange={(e) =>props.onustomerNeedAnyOtherServiceOptionChange(e,original)}
													isClearable
													value={getSelectedItem(props.customerNeedAnyOtherServiceOptions,props.selectedServiceForEdit.custOtherServiceInfo)}
												></Select>
											}
										</>							
									):
									(
										<>
											<span>{getSelectedItemLable(props.customerNeedAnyOtherServiceOptions,original.custOtherServiceInfo)||""}</span>
										</>
									)
								}
								
							</>
						)
					},
					/*{
						id: "nResourceInstanceId",
						Header: "deAsra Notes",
						accessor: "nResourceInstanceId",
						width: 200,
						Cell:({original})=>(
							<>
								{
									<ESPNotesLogDropdown 
									nResourceInstanceId={original.nResourceInstanceId} 
									serviceFrom={original.serviceFrom}/>
								}
								
							</>
						)
					},*/
					
					{
						id: "custfGovtCharges",
						Header: "Government Charges",
						headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
						accessor: "custfGovtCharges",
						show:getShowChargesColumn(),
						width: 200,
						Cell:({original})=>(
							<>
								{
									props.selectedServiceForEdit&&props.selectedServiceForEdit.nResourceInstanceId&&props.selectedServiceForEdit.nResourceInstanceId===original.nResourceInstanceId?				
									(
										<>	
											<ControlledInput
													placeholder="Government charges"
													name="custfGovtCharges"
													onChange={({ target: { name, value } }) =>									
													props.handleServiceRequestsNotesChange(name, value)}
													value={props.selectedServiceForEdit.custfGovtCharges}
													autoFocus={props.activeFocus==="custfGovtCharges"}
													autoComplete="off"
													onFocus={(e)=>e.currentTarget.setSelectionRange(e.currentTarget.value.length, e.currentTarget.value.length)}	
												/>
										</>							
									):
									(
										<>
											<span>{original.custfGovtCharges?
												original.custfGovtCharges:""}</span>
										</>							
									)
								}
								
							</>
						),
					},   
					{
						id: "custfAffiliateFees",
						Header: "Affiliate Fees",
						headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
						accessor: "custfAffiliateFees",
						show:getShowChargesColumn(),
						width: 200,
						Cell:({original})=>(
							<>
								{
									props.selectedServiceForEdit&&props.selectedServiceForEdit.nResourceInstanceId&&props.selectedServiceForEdit.nResourceInstanceId===original.nResourceInstanceId?				
									(
										<>	
											<ControlledInput
													placeholder="Affiliate fees"
													name="custfAffiliateFees"
													onChange={({ target: { name, value } }) =>									
													props.handleServiceRequestsNotesChange(name, value)}
													value={props.selectedServiceForEdit.custfAffiliateFees}
													autoFocus={props.activeFocus==="custfAffiliateFees"}
													autoComplete="off"
													onFocus={(e)=>e.currentTarget.setSelectionRange(e.currentTarget.value.length, e.currentTarget.value.length)}	
												/>
										</>							
									):
									(
										<>
											<span>{original.custfAffiliateFees?
												original.custfAffiliateFees:""}</span>
										</>							
									)
								}
								
							</>
						),
					},   
					{
						id: "custfProfessionalCharges",
						Header: "Professional Charges",
						headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
						accessor: "custfProfessionalCharges",
						show:getShowChargesColumn(),
						width: 200,
						Cell:({original})=>(
							<>
								{
									props.selectedServiceForEdit&&props.selectedServiceForEdit.nResourceInstanceId&&props.selectedServiceForEdit.nResourceInstanceId===original.nResourceInstanceId?				
									(
										<>	
											<ControlledInput
													placeholder="Professional charges"
													name="custfProfessionalCharges"
													onChange={({ target: { name, value } }) =>									
													props.handleServiceRequestsNotesChange(name, value)}
													value={props.selectedServiceForEdit.custfProfessionalCharges}
													autoFocus={props.activeFocus==="custfProfessionalCharges"}
													autoComplete="off"
													onFocus={(e)=>e.currentTarget.setSelectionRange(e.currentTarget.value.length, e.currentTarget.value.length)}	
												/>
										</>							
									):
									(
										<>
											<span>{original.custfProfessionalCharges?
												original.custfProfessionalCharges:""}</span>
										</>							
									)
								}
								
							</>
						),
					}, 
					{
						id: "custfTotalCharges",
						Header: "Total Charges",
						headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
						accessor: "custfTotalCharges",
						show:getShowChargesColumn(),
						width: 200,
						Cell:({original})=>(
							<>
								{
									props.selectedServiceForEdit&&props.selectedServiceForEdit.nResourceInstanceId&&props.selectedServiceForEdit.nResourceInstanceId===original.nResourceInstanceId?				
									(
										<>	
											<ControlledInput
													placeholder="Total charges"
													name="custfTotalCharges"
													onChange={({ target: { name, value } }) =>									
													props.handleServiceRequestsNotesChange(name, value)}
													value={props.selectedServiceForEdit.custfTotalCharges}
													autoFocus={props.activeFocus==="custfTotalCharges"}
													autoComplete="off"
													onFocus={(e)=>e.currentTarget.setSelectionRange(e.currentTarget.value.length, e.currentTarget.value.length)}	
												/>
										</>							
									):
									(
										<>
											<span>{original.custfTotalCharges?
												original.custfTotalCharges:""}</span>
										</>							
									)
								}
								
							</>
						),
					}, 
				]
			},
			{
				Header: "Facilitator",
				columns: [
					{
						id: "facilitator"+"nResourceInstanceId",
						Header: "Facilitator",
						headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc','borderLeft':'solid 1px #ccc'},
						accessor: "nResourceInstanceId",
						className:"left-boder",
						width: 200,
						Cell: ({ original }) => (
							original.existing_service_facilitator ? 
							original.existing_service_facilitator.email :
							original.refFacilitator?
							original.refFacilitator.email:
							//original.refFacilitator.first_name+' '+original.refFacilitator.last_name:
							""
						),
						className:"gray-bg"
					}, 
				]
			},
			/*{
				Header: "Action",
				fixed: "right",
				columns: [
					{
						id: "id",
						Header: "Action",
						headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
						accessor: "id",
						Cell: ({ original }) =>
						(
							<>
								{
									props.selectedServiceForEdit&&props.selectedServiceForEdit.nResourceInstanceId&&props.selectedServiceForEdit.nResourceInstanceId===original.nResourceInstanceId?				
									(
										<>	
											<button className="btn r-button primary"
											onClick={(e) =>props.onRowSave(e,original)}>
												Save
											</button>
			
											<button 
												className="btn r-button primary"
												style={{marginLeft:"5px"}}
												onClick={(e) =>props.onRowCancelEdit(e,original)}>
													Cancel
											</button>
										</>							
									):
									(
										<>
											{original.custrefSRState=="Cancelled"||original.custrefSRState=="Delivered"?
											(
												<span>{"NA"}</span>
											):
											(
												<button className="btn r-button primary" onClick={(e) =>props.onRowDoubleClick(e,original)}>
													Edit
												</button>
											)}
										</>
									)
								}
							</>
						),
						width: 140,
					},		
				]
			}*/      
			
		]

		setTablecolumns(columns);
	}

	useEffect(() => {
		setColumns();
	}, [props.ExternalServicePartnerOrganization]);

    const getSelectedItem = (Options,value) => {
		if (!Options) return;
		const found = find(Options, {
			value: value,
		});
		if (found) {
			return found;
		}
		return ;
	};

	const getShowChargesColumn=()=>{

		if (props.ExternalServicePartnerOrganization&&props.ExternalServicePartnerOrganization.includes("Vakilsearch"))
		{
			return true;
		}
		return false;
	}

	const getSelectedItemLable = (Options,value) => {
		if (!Options) return;
		const found = find(Options, {
			value: value,
		});
		if (found) {
			return found.label;
		}
		return ;
	};

    

    return (
        <div className={`row row-container ${props.isLoading && "set-opacity"}`} >
			{props.isLoading && <Spinner className="center-screen" />}
			{/*}<div className="col-12">
				<label>
					<b>Service Requests</b>
				</label>
			</div>*/}	
			<div className="col-12 inline-margin-ESPView-Admin">				
				<div className="multi-select"> 
					<MultiSelectAll
						toggleAll={props.toggleAllForFilter}
						toggleSelection={props.toggleSelectionForFilter}
						checkboxItemsList={props.serviceNameListForFilter}
						selectedOptions={props.selectedServiceNameListForFilter}
						placeholderButtonLabel={"Select Services"}
					/>
				</div>
				<SelectServiceStatusDropdown
						toggleSelection={props.toggleServiceStatus}
						checkboxItemsList={props.serviceStatusList}
				/>
				{/*<div>
					<Button className="inline-button" onClick={props.onSearchClicked}>Search</Button>
					<Button className="inline-button" onClick={props.onClearFilterSearch}>Clear</Button>
				</div>*/}
				<div className="small-dropdown">
					<label style={{marginTop:"5px"}}><b>Requested a callback:</b></label>
					<Select
						styles={{
							// Fixes the overlapping problem of the component
							menu: provided => ({ ...provided, zIndex: 3 })
						}}
						placeholder="Select Requested a callback"
						options={props.requestedaCallBackOptions}
						onChange={props.setSelectedRequestedaCallBackOption}
						value={props.selectedRequestedaCallBackOption}
					></Select>
				</div>
				<div className="small-dropdown">
					<label style={{marginTop:"5px"}}><b>Need to talk to SP:</b></label>
					<Select
						styles={{
							// Fixes the overlapping problem of the component
							menu: provided => ({ ...provided, zIndex: 3 })
						}}
						placeholder="Select Need to talk to SP"
						options={props.requestedaCallBackOptions}
						onChange={props.setSelectedNeedToTalkToSPOption}
						value={props.selectedNeedToTalkToSPOption}
					></Select>
				</div>
				<div className="small-dropdown">
					<label style={{marginTop:"5px"}}><b>Requested by:</b></label>
					<Select
						styles={{
							// Fixes the overlapping problem of the component
							menu: provided => ({ ...provided, zIndex: 3 })
						}}
						placeholder="Select Requested by"
						options={props.requestedByOptions}
						onChange={props.setSelectedRequestedByOption}
						value={props.selectedRequestedByOption}
					></Select>
				</div>
				<div className="small-dropdown-call">
					<label style={{marginTop:"5px"}}><b>Call Status:</b></label>
					<Select
						styles={{
							// Fixes the overlapping problem of the component
							menu: provided => ({ ...provided, zIndex: 3 })
						}}
						placeholder="Select call status"
						options={props.callStatusOptionsForFilter}
						onChange={props.setselectedCallStatusOptionForFilter}
						value={props.selectedCallStatusOptionForFilter}
					></Select>
				</div>
				<div style={{clear:"both"}}></div>
				<div className="inline-margin-ESPView-Admin" style={{marginTop:"10px"}}>
					<Select
						styles={{
							// Fixes the overlapping problem of the component
							menu: provided => ({ ...provided, zIndex: 3 })
						}}
						options={props.externalServicePartnerOptions}
						onChange={props.onExternalServicePartnerChange}
						value={props.selectedExternalServicePartner}
					/>
					<ReactDatePicker
						dateFormat="dd/MM/yyyy"
						selected={props.fromDate}
						onChange={(date) =>props.setfromDate(date)}
						placeholderText="Service Request From Date"
					/>
					<ReactDatePicker
						dateFormat="dd/MM/yyyy"
						selected={props.toDate}
						onChange={(date) =>props.settoDate(date)}
						placeholderText="Service Request To Date"
					/>
					<div className={"package-dropdown"}>
						<Select
							styles={{
								// Fixes the overlapping problem of the component
								menu: provided => ({ ...provided, zIndex: 3 })
							}}
							placeholder="Select Package/Offering"
							options={props.packageNameListForFilter}
							onChange={(option) => {
								props.setSelectedPackageNameListForFilter(option);
							}}
							value={props.selectedPackageNameListForFilter}
							isClearable
						></Select>
					</div>
					
					<ControlledInput
						placeholder="Search..."
						// onChange={(event) => { event.persist();debounce(() => {props.onSearchInputChange(event)},1000)}}
						onChange={props.onSearchInputChange}
						onKeyPress={(e) => {
							if (e.key === "Enter") {
								props.onSearchClicked();
							}
						}}
						value={props.searchTerm}
						name="searchTerm"
					/>
					<div className="small-dropdown-rows">
						<Select
							styles={{
								// Fixes the overlapping problem of the component
								menu: provided => ({ ...provided, zIndex: 3 })
							}}
							options={props.pageSizeOptions}
							onChange={props.onPageSizeOptionChange}
							value={props.selectedPageSizeOption}
						></Select>
					</div>
					<div>
						<Button className="inline-button" onClick={props.onSearchClicked}>Search</Button>
						<Button className="inline-button" onClick={props.onClearFilterSearch}>Clear</Button>
					</div>
					{/*<div>
					<Button className="inline-button float-right" onClick={props.handleReportsClick}>Reports</Button>
                    </div>*/}
				</div>
								
			</div>
			<div style={{clear:"both"}}></div>	
            <div className="col-12 admin-service-partner" style={{marginTop:"10px"}}>
                {/*props.showTable?(*/<ReactTableFixedColumns
					//ref={reactTable}
                    data={props.data || []}
                    columns={Tablecolumns}
					manual
					//defaultPage={props.page}
					pages={props.pages}
					page={props.page}
					pageSize={props.pageSize}
					sortable={false}
                    showPagination={true}
					pageSizeOptions={[10,20,30]}
					onFetchData={(state, instance) => {
						props.onFetchServiceRequests(instance, false);
						//instance.state.pages = props.pages;
					}}
					
					/*onPageChange={pageIndex => {
						props.changePage(pageIndex)
						reactTable.current.props.onFetchData();
					}}*/
					PaginationComponent={Pagination}
                    style={{overflowY: "auto",height: "480px"}}			
                    NextComponent={(instance) => (
                        <Button className="mt3" {...instance}>
                            Next
                        </Button>
                    )}
                    PreviousComponent={(instance) => (
                        <Button className="mt3" {...instance}>
                            Previous
                        </Button>
                    )}
					className="-striped"
                />/*):""*/}
            </div>
			{
				showViewAllNotesModal&&
				(
					<CentralizedNotesModal
						isOpen={showViewAllNotesModal}
						toggleModal={toggleViewAllNotesModal}
						sEmailAddress={selectedCustomerEmailId}
						serviceNameListESP={props.serviceNameListForFilter}
					>
					</CentralizedNotesModal>
				)
			}
        </div>	
			
	);
}